import { INITIALIZE_SERVICES_CATALOG } from '../constants';

const initialState = [];

const servicesCatalogReducer = (state = initialState, action) => {
  switch (action.type) {
    case INITIALIZE_SERVICES_CATALOG:
      return action.payload;
    default:
      return state;
  }
};

export default servicesCatalogReducer;
